/**
 * created by hezq on 2019-10-24
 *
 * description： 接口配置模块化管理
 *
 */

import common from 'api/common.js';
import home from 'api/home';
import handle from 'api/handle';
import mine from 'api/mine';
import setting from 'api/setting';

const api = {
	common: common,
	home: home,
	handle: handle,
	mine: mine,
	setting: setting,
};

export default api;



// WEBPACK FOOTER //
// ./src/api/index.js